import { ProductInfo } from '../domain-models/product-info.model';
import { AppActionTypes, ApplicationActions } from '../store/application-actions';

export function onLoadAgent(dispatch: React.Dispatch<ApplicationActions>, agent: ProductInfo): void {
  dispatch({ type: AppActionTypes.LOAD_AGENT, payload: agent.id });
  dispatch({ type: AppActionTypes.SET_AGENT_DETAILS, payload: agent });
  dispatch({ type: AppActionTypes.START_CONVERSATION });
}
